import { Component } from 'react';
import {
    FormControl,
    ListSubheader,
    MenuItem,
    Select,
    Typography,
} from '@mui/material';


class PlayerSelect extends Component {
    constructor(props) {
      super(props);
      const defaultValue = this.props.player
        ? this.props.player.playerId || ""
        : "";
      this.state = { value: defaultValue };
      this.id = props.id;
    }

    componentDidUpdate(previousProps) {
      const previousId = previousProps.player?.playerId || "";
      const playerId = this.props.player?.playerId || "";
      if (String(previousId) !== String(playerId) && String(playerId) !== this.state.value) {
        this.setState({ value: String(playerId) });
      }
    }
  
    handlePlayerSelect = (e) => {
      const value = e.target.value;
  
      // Update local state
      this.setState({ value });
  
      // Notify parent of the selection change
      if (this.props.onChange) {
        this.props.onChange(value);
      }
    };
  
    render() {
      const grandPrixIds = new Set((this.props.grandPrixRoster || this.props.roster || [])
        .map((player) => String(player.playerId)));
      const grandPrixPlayers = this.props.roster?.filter((player) =>
        grandPrixIds.has(String(player.playerId))) || [];
      const substitutes = this.props.roster?.filter((player) =>
        !grandPrixIds.has(String(player.playerId))) || [];
      const renderPlayer = (player, substitute = false) => {
        const playerId = String(player.playerId);
        const playerName = player.fullName ||
          `${player.firstName || ''} ${player.lastName || ''}`.trim();
        return (
          <MenuItem
            value={playerId}
            key={`player-${this.id}-player-key-${playerId}`}
          >
            {playerName}{substitute ? ' (Substitute)' : ''}
          </MenuItem>
        );
      };

      return (
        <FormControl fullWidth>
          <Select
            labelId={`player-select-${this.id}`}
            id={`player-select-${this.id}`}
            value={this.state.value}
            displayEmpty
            variant="outlined"
            inputProps={{ MenuProps: { disableScrollLock: true } }}
            onChange={this.handlePlayerSelect}
            style={{
              fontSize: "15px",
              fontWeight: "bold",
              height: "60px",
              backgroundColor: "white",
            }}
          >
            {/* Placeholder MenuItem */}
            <MenuItem value="" disabled>
              <Typography fontWeight="bold" color="gray">
                Player {this.id + 1}
              </Typography>
            </MenuItem>
  
            <ListSubheader>Grand Prix players</ListSubheader>
            {grandPrixPlayers.map((player) => renderPlayer(player))}
            {substitutes.length > 0 && <ListSubheader>Substitutes</ListSubheader>}
            {substitutes.map((player) => renderPlayer(player, true))}
          </Select>
        </FormControl>
      );
    }
  }
  
  export default PlayerSelect;
